import { Dispatch, SetStateAction, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { CheckText } from '../../../components/common/CheckText';
import { Hub } from '../../../components/common/Hub/Hub';
// import { VirtualOfficePlan } from '../../../components/common/VirtualOfficeSubscription/VirtualOfficePlan';
import { P2 } from '../../../styles/FontStyles';
import { Button } from '../../../styles/GlobalComponents';
import { PurchaseSteps } from '../Maeketplace.types';
import { ErrorToast } from '../../../components';

export const VirtualOfficeSubscriptionStyled = styled.div`
  cursor: pointer;
  background: ${(props) => props.theme.colors.secondaryBlue};
  border-radius: 12px;
  padding: 20px;
  width: 100%;
  margin-bottom: 20px;
  @media (max-width: 800px) {
    padding: 16px;
  }
`;

interface InitialProps {
  setStep: Dispatch<SetStateAction<any>>;
  setModal: Dispatch<SetStateAction<boolean>>;
  selectedPackage: any;
  selectedLicence: any;
  setSelectedLicence: any;
  licenceDate: number;
}

export const Initial = ({
  setStep,
  selectedPackage,
  setModal,
  selectedLicence,
  setSelectedLicence,
  licenceDate
}: InitialProps) => {
  const [checkbox, setCheckbox] = useState(false);
  const { t } = useTranslation('marketplace');

  const handleWithLicence = () => {
    if (!selectedLicence)
      return ErrorToast('Please select backoffice subscription');

    setStep(PurchaseSteps.PAYMENT_METHOD);
  };

  const handleWithoutLicence = () => {
    setStep(PurchaseSteps.PAYMENT_METHOD);
    setSelectedLicence(null);
  };

  if (!selectedPackage?.packageId) return null;

  const {
    packageId,
    image,
    name,
    price,
    weeklyCap,
    limitedQuantity,
    tradingBinaryPercentage,
    calculator,
    willyMemeCoins,
    subtitle,
    tickets,
    subscriptionPrice
  } = selectedPackage;

  const amountToPay = selectedLicence
    ? subscriptionPrice
      ? selectedLicence.price + price + subscriptionPrice
      : selectedLicence.price + price
    : subscriptionPrice
    ? subscriptionPrice + price
    : price;
  return (
    <div>
      {/* <VirtualOfficePlan
        selected={selectedLicence}
        setSelected={setSelectedLicence}
      /> */}

      <P2 mt='20' mb='40'>
        {licenceDate === 0 ? (
          <div style={{ display: 'inline' }}>
            {t('mavie_backoffice_text1')} <b>{t('mavie_backoffice_text2')} </b>
          </div>
        ) : (
          <div style={{ display: 'inline' }}>
            {t('subscription_expiring')}{' '}
            <b>{t('next_days', { licenceDate })} </b>
          </div>
        )}
        {t('members_without_backoffice_text1')}
        <b> {t('members_without_backoffice_text2')} </b>{' '}
        {t('members_without_backoffice_text3')}
      </P2>

      <P2 mb='5'>&#x274C; {t('business_volume_points')} </P2>

      <P2 mb='32'>&#x274C; {t('bonuses_capped')}</P2>

      <Button mt={16} onClick={handleWithLicence}>
        {t('continue_with_subscription')}
      </Button>

      <P2 mt='40' mb='20' bold>
        {t('selected_staking_hub_nft')}:
      </P2>

      <Hub
        id={packageId}
        key={packageId}
        condensed
        image={image}
        title={name}
        showTickets={packageId >= 170 && packageId < 180}
        price={subscriptionPrice ? price : amountToPay}
        subscriptionPrice={subscriptionPrice}
        selectedLicence={selectedLicence}
        subtitle={subtitle}
        tickets={tickets}
        packagePrice={price}
        weeklyCap={weeklyCap}
        limitedQuantity={limitedQuantity}
        dobuleTradingBinaries={tradingBinaryPercentage}
        includesSubscription={selectedLicence?.access}
        willyMemeCoins={willyMemeCoins}
        info={<></>}
      />

      <CheckText
        checked={checkbox}
        onClick={() => setCheckbox(!checkbox)}
        text={t('checkbox_confirm')}
      />
      <Button mt={16} disabled={!checkbox} onClick={handleWithoutLicence}>
        {t('continue_without_subscription')}
      </Button>
    </div>
  );
};
